module.exports = __webpack_public_path__ + "static/media/slajd-2.13f6c064.jpg";